<template>
    <Dialog 
          :header="formMode == 'edit' ? 'Chỉnh sửa vật tư - dịch vụ': 'Tạo mới vật tư - dịch vụ'"
          :visible.sync="displayDialog"
          :contentStyle="{overflow: 'visible'}"
          :style="{width: '40vw'}"
          :class="'popup-dialog'"
          :modal="true"
        >
        <div class="p-fluid">
            <div class="p-col-12 form-popup-custom">
                <div class="p-field">
                    <label>Mã vật tư - dịch vụ<span class="error">*</span></label>
                </div>
                <div class="p-field">
                    <InputText maxlength="255" id="code" type="text" v-model="objectData.code" />
                  <small v-if="validationErrors && validationErrors['code']"
                         class="p-invalid">{{ validationErrors['code'] }}</small>
                </div>
            </div>
          <div class="p-col-12 form-popup-custom">
            <div class="p-field">
              <label>Tên vật tư - dịch vụ<span class="error">*</span></label>
            </div>
            <div class="p-field">
              <InputText  maxlength="255" id="name" type="text" v-model="objectData.name" :placeholder="'Nhập tên vật tư - dịch vụ'" />
              <div v-if="validationErrors && validationErrors['name']">
                <small v-if="validationErrors['name'] == 1"
                       class="p-invalid" >Nhập tên vật tư - dịch vụ</small>
                <small v-if="validationErrors['name'] == 2"
                       class="p-invalid" >Tên vật tư - dịch vụ đã tồn tại</small>
              </div>
            </div>
          </div>
          <div class="p-col-12 form-popup-custom">
            <div class="p-grid">
              <div class="p-col-6">
                <div class="p-field">
                  <label>Đơn vị tính<span class="error">*</span></label>
                </div>
                <div class="p-field">
                  <Dropdown inputId="unit" v-model="objectData.unit" :options="list_unit" optionLabel="label"  optionValue="value" placeholder="Chọn đơn vị tính"/>
                  <div v-if="validationErrors && validationErrors['unit']">
                    <small v-if="validationErrors['unit'] == 1"
                           class="p-invalid" >Chọn đơn vị tính</small>
                  </div>
                </div>
              </div>
              <div class="p-col-6">
                <div class="p-field">
                  <label>Đơn giá</label>
                </div>
                <div class="p-field">
                  <div style="width: 100%">
                    <InputNumber v-model="objectData.unit_price" style="width: 80%" placeholder="0"/>
                    <span style="font-size: 14px">
                      VNĐ
                    </span>
                    <div v-if="validationErrors && validationErrors['unit_price']">
                      <small v-if="validationErrors['unit_price'] == 1"
                             class="p-invalid" >Vui lòng nhập số dương.</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            <div class="p-col-12 form-popup-custom">
                <div class="p-field">
                    <div class="p-field-checkbox">
                        <Checkbox  v-model="objectData.status" :binary="true"/>
                        <label >Hiển thị sử dụng</label>
                    </div>
                </div>
            </div>
            
        </div>
        <template #footer>
            <Button :disabled="submitForm" class="p-button-success" :label="formMode == 'edit' ? 'Lưu' : 'Tạo'" @click="saveData" />
        </template>
      </Dialog>
</template>

<script>
import DataServices from '@/core/DataServices'

export default {
  props: {
    show: Boolean,
    mode: String,
    modelName: String,
    model: Object,
    screen: String
  },
  data() {
    return {
        name: '',
        status: true,
        parent_id: 0,
        is_management: true,
        displayDialog: this.show,
        validationErrors: {},
        name_exists: false,
        optionsParent: [],
        submitForm: false,
        levelParentIndex: 0,
        description: '',
        list_unit:[],
        objectData: {
          code: '',
          name: '',
          unit: null,
          unit_price: 0,
          status: true,
        }
    }
  },
  async created() {
    this.formMode = this.mode;
    var unit_active = null;
    if (this.formMode === 'edit' && this.model !== undefined && this.model !== null && Object.entries(this.model).length) {
     this.objectData = this.$myConstants.convertJsonObject(this.model);
      unit_active = this.objectData.unit;
    }
    this.load_unit(unit_active);
  },
  methods: {
    async getCodeNext() {
      var data =await DataServices.getObjectData('service_supplies',{},{id: 'desc'});
      if (!this.$myConstants.isEmpty(data)){
        var codeLast = data.code;
        var codeRightLast = codeLast.substring((codeLast.length - 6));//Cắt lấy 6 ký tự cuối cùng
        var codeRightTmp =(parseInt(codeRightLast) + 1).toString();
        return 'VT'+codeRightTmp.padStart(6, '0');
      }
      return 'VT000001';
    },
    async load_unit(unit_active = null) {
        var whereKey = {
            status: {'_in': [0, 1] }
        }
        var variables = {
            where_key: whereKey
        }
        var data = await DataServices.getList('service_unit', {"variables": JSON.stringify(variables)});
        var list = data[Object.keys(data)];
        if (list !== undefined && list !== null && Object.keys(list).length) {
            for (let index = 0; index < list.length; index++) {
                const item = list[index];
              this.list_unit.push({label: item.name, value: item.code, item: item});
            }
            if (!this.$myConstants.isEmpty(unit_active)){
              this.objectData.unit = unit_active;
            }
        }
    },
    async validateData() {
        var vm = this;
        this.validationErrors = {};
      if (this.$myConstants.isEmpty(this.objectData.code)){
        this.validationErrors["code"] = "Nhập mã vật tư - dịch vụ";//empty tên
      }else {
        var where_check_code = { code: {'_ilike': this.objectData.code} }
        if (this.formMode === 'edit'){
          where_check_code.id = {_neq: this.model.id};
        }
        var check_code =await DataServices.getObjectData('service_supplies',where_check_code,null);
        if (!vm.$myConstants.isEmpty(check_code)){
          vm.validationErrors["code"] = "Mã vật tư - dịch vụ đã tồn tại";
        }
      }
        if (this.$myConstants.isEmpty(this.objectData.name)){
          this.validationErrors.name = 1;//empty tên
        }else {
          var where_check_name = { name: {'_ilike': this.objectData.name} }
          if (this.formMode === 'edit'){
            where_check_name.id = {_neq: this.model.id};
          }
          var check_name =await DataServices.getObjectData('service_supplies',where_check_name,null);
          if (!vm.$myConstants.isEmpty(check_name)){
            vm.validationErrors.name = 2;//Trùng tên vật tư
          }
        }
      if (this.$myConstants.isEmpty(this.objectData.unit)){
        this.validationErrors['unit'] = 1;//chọn unit
      }
      if (!this.$myConstants.isEmpty(this.objectData.unit_price)){
        if (parseFloat(this.objectData.unit_price) < 0){
          this.validationErrors['unit_price'] = 1;//nhập số duong
        }
      }

      if (!(Object.entries(this.validationErrors).length === 0)) {
        //Nếu tồn tại lỗi thì force để load validator mượt
        this.$forceUpdate();
      }
    },
    /*async checkName() {
        this.name = this.name.trim();
        if (this.name !== undefined && this.name !== "") {
            var where = { name: {'_ilike': this.name} }
            if (this.model !== undefined) where = Object.assign(where, {id: {'_neq': this.model.id}})
            var data = await DataServices.getList(this.modelName, {"fields": "id", "variables": JSON.stringify({where_key: where})});
            return data && data[Object.keys(data)].length > 0
        }
    },*/
    async saveData() {
      var vm = this;
        this.submitForm = true;
        var organization = this.$myConstants.organizationUserLogin();
        var creator_organization_id = (!this.$myConstants.isEmpty(organization.id)) ? organization.id:null;
        await this.validateData();
        if (Object.entries(this.validationErrors).length === 0) {
            var params = {
                'code': vm.objectData.code,
                'name': vm.objectData.name.trim(),
                'unit': vm.objectData.unit,
                'unit_price': !this.$myConstants.isEmpty(vm.objectData.unit_price) ? vm.objectData.unit_price:0,
                'status': this.objectData.status ? 1 : 0,
                'modifier_id': this.$store.getters.fullname.id
            }
            if (this.formMode === 'add') {
                //params.code = await this.getCodeNext();
                params = Object.assign(params, { 'creator_organization_id': creator_organization_id})
                params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() })
                params = Object.assign(params, { 'created_date': this.$myConstants.currentDate() })
                await DataServices.insertData(this.modelName, {"variables": JSON.stringify({objects: params})}).then(async () => {
                  if (vm.screen == 'service_park'){
                    this.$emit('save_service_supplies');
                  }else {
                    vm.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Tạo mới thành công', life: 3000 })
                    vm.displayDialog = false;
                    vm.$emit('refresh');
                  }
                }).catch(async () => {
                  vm.$toast.add({
                    severity: 'error',
                    summary: 'Thông báo',
                    detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
                    life: 3000
                  });
                  vm.submitForm = false;
                });
            } else {
                params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() });
                await DataServices.updateData(this.modelName, {"variables": JSON.stringify({data_update: params, where_key: { id: {'_eq': this.model.id }}})}).then(async () => {
                  vm.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 })
                  vm.displayDialog = false;
                  vm.$emit('refresh');
                }).catch(async () => {
                  vm.$toast.add({
                    severity: 'error',
                    summary: 'Thông báo',
                    detail: 'Hệ thống đã gặp sự cố !Xin vui lòng thử lại.',
                    life: 3000
                  });
                  vm.submitForm = false;
                });


            }
        } else this.submitForm = false;
    },
    async getLevelIndex(whereKey) {
        var variables = {
            where_key: whereKey,
            orderBy: {
                'level_parent_index': 'desc'
            },
            limit: 1
        }
        var data = await DataServices.getList(this.modelName, {"fields": "id parent_id level_parent_index", "variables": JSON.stringify(variables)});
        if (data[Object.keys(data)].length) {
            data = data[Object.keys(data)][0];
            return data;
        }
        return null;
    },
  }
}
</script>

<style lang="scss" scoped>
</style>